import type { Vec3 } from "@rietz/shared";

/**
 * The frozen shot after a death: the camera sits at the killer's eye and looks
 * at the body. Pure geometry — the loop owns the camera, `main.ts` the clock.
 */

/** How long the camera sits at the shooter after a death, ms. */
export const KILLCAM_MS = 3000;

/** How far above the victim's feet the camera aims — the body, not the dirt. */
export const KILLCAM_BODY_Y = 0.3;

/**
 * Yaw/pitch that look from `from` to `to`, in the camera's convention: forward
 * is (−sin yaw, sin pitch, −cos yaw) (`sim/movement.ts`), positive pitch up.
 * A degenerate (zero) vector looks down −Z, level.
 */
export function lookAngles(
  from: Readonly<Vec3>,
  to: Readonly<Vec3>,
): { yaw: number; pitch: number } {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  const dz = to.z - from.z;
  const flat = Math.hypot(dx, dz);
  if (flat < 1e-6 && Math.abs(dy) < 1e-6) return { yaw: 0, pitch: 0 };
  return { yaw: Math.atan2(-dx, -dz), pitch: Math.atan2(dy, flat) };
}
